import React from 'react';
import { Form, Formik } from 'formik';
import FormikFieldWrapper from '../general/formikFieldWrapper/formikFieldWrapper';
// @ts-ignore
import { Button, Loader } from 'arag-ui-lib';
import { useTranslation } from 'react-i18next';
type Props = {
    submitting: boolean;
    handleUserInfoSubmit: (values: { email: string; passcode: string }) => void;
};

const PolicyHolderReviewClaimForm = (props: Props): JSX.Element => {
    const { submitting, handleUserInfoSubmit } = props;
    const { t } = useTranslation();
    return (
        <div id={'claim_review_user_info_wrapper'} className={''}>
            <div id={'claim_review_user_info_row'} className={'row'}>
                <div
                    id={'claim_review_user_info_title'}
                    className="col-xs-7 col-xs-offset-3"
                    style={{ marginBottom: 45 }}
                >
                    {t('reviewClaimDescription') as string}
                </div>
            </div>
            <Formik initialValues={{} as any} onSubmit={handleUserInfoSubmit}>
                {({ values }) => {
                    return (
                        <div id={'claim_review_user_info_form_wrapper'}>
                            <Form
                                className="form-horizontal"
                                autoComplete="off"
                                autoCorrect="off"
                                spellCheck="false"
                                id={'claim_review_user_info_form'}
                            >
                                <div
                                    id={'claim_review_user_info_email_wrapper'}
                                    className="col-sm-offset-2"
                                >
                                    <FormikFieldWrapper
                                        labelSize={'col-sm-3'}
                                        inputSize={'col-sm-7'}
                                        label={`${t('email')}`}
                                        variant={'text'}
                                        inputProps={{
                                            id: 'claim_review_user_info_email',
                                            name: 'email',
                                            required: true,
                                            onInvalid: (
                                                e: React.InvalidEvent<HTMLInputElement>,
                                            ) => {
                                                e.target.setCustomValidity(
                                                    t('requiredField'),
                                                );
                                            },
                                            onInput: (
                                                e: React.FormEvent<HTMLInputElement>,
                                            ) => {
                                                e.currentTarget.setCustomValidity(
                                                    '',
                                                );
                                            },
                                            title: t('requiredField'),
                                        }}
                                    />
                                    <FormikFieldWrapper
                                        labelSize={'col-sm-3'}
                                        inputSize={'col-sm-7'}
                                        label={`${t('passcode')}`}
                                        variant={'text'}
                                        inputProps={{
                                            id: 'claim_review_user_info_passcode',
                                            name: 'passcode',
                                            required: true,
                                            type: 'password',
                                            onInvalid: (
                                                e: React.InvalidEvent<HTMLInputElement>,
                                            ) => {
                                                e.target.setCustomValidity(
                                                    t('requiredField'),
                                                );
                                            },
                                            onInput: (
                                                e: React.FormEvent<HTMLInputElement>,
                                            ) => {
                                                e.currentTarget.setCustomValidity(
                                                    '',
                                                );
                                            },
                                            title: t('requiredField'),
                                        }}
                                    />
                                </div>
                                <div
                                    id={'claim_review_user_info_button_wrapper'}
                                    className={'form-group'}
                                >
                                    <div
                                        id={
                                            'claim_review_user_info_button_column'
                                        }
                                        className={
                                            'col-sm-offset-9 col-xs-offset-1'
                                        }
                                    >
                                        <Button
                                            id={'claim_review_user_info_submit'}
                                            type="submit"
                                            variant="primary"
                                            label={`${t('submit')}`}
                                            onClick={() => null}
                                        />
                                        {submitting && (
                                            <Loader
                                                id={
                                                    'claim_review_user_info_loader'
                                                }
                                                variant="inline"
                                                label={`${t('submitting')}`}
                                            />
                                        )}
                                    </div>
                                </div>
                            </Form>
                        </div>
                    );
                }}
            </Formik>
        </div>
    );
};

export default PolicyHolderReviewClaimForm;
